import request from '@/utils/request'

export function getDocList(param) {
  let data = param
  return request({
    url: `/a8000/getDocList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}


export function getFilePdf(param) {
  return request({
      url: `/a8000/getFilePdf`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      responseType: 'blob',  
      data: param
  })
}


